
import request from '../utils/request'

const prefix = '/api/v1/back'
/**
 * 录取登记院校专业（查询列表）
 * @param {*} query
 */
export const collegeMajorList = (query) => {
  return request({
    url: `${prefix}/recruitRegister/collegeMajor/list`,
    method: 'get',
    params: query
  })
}
/**
 * 录取登记院校专业（批量删除）
 * @param {*} query
 */
export const collegeMajorDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister/collegeMajor/list`,
    method: 'delete',
    data: query
  })
}

/**
 * 录取登记院校专业（导出）
 * @param {*} query
 */
export const collegeMajorExport = (query) => {
  return request({
    url: `${prefix}/recruitRegister/collegeMajor/list/export`,
    method: 'get',
    params: query
  })
}
/**
 * 院校简介查询详情（导出）废弃：/recruitRegister/collegeIntroduct
 * @param {*} query 
 */
export const collegeIntroductDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/collegeIntroduct`,
    method: 'get',
    params: query
  })
}

/**
 * 院校简介（创建）
 * @param {*} query
 */
export const collegeIntroductCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/collegeIntroduct`,
    method: 'post',
    data: query
  })
}
/**
 * 院校简介（编辑）
 * @param {*} query
 */
export const collegeIntroductPut = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/collegeIntroduct`,
    method: 'put',
    data: query
  })
}



/**
 * 复试名单（查询）
 * @param {*} query
 */
export const secondExamRosterList = (query) => {
  return request({
    url: `${prefix}/recruitRegister/secondExamRoster/list`,
    method: 'get',
    params: query
  })
}
/**
 * 复试名单（详情）
 * @param {*} query
 */
export const secondExamRosterDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister/secondExamRoster`,
    method: 'get',
    params: query
  })
}
/**
 * 复试名单（删除）
 * @param {*} query
 */
export const secondExamRosterDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister/secondExamRoster/list`,
    method: 'delete',
    data: query
  })
}

/**
 * 复试名单（创建）
 * @param {*} query
 */
export const secondExamRosterCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister/secondExamRoster`,
    method: 'post',
    data: query
  })
}
/**
 * 复试名单（编辑）
 * @param {*} query
 */
export const secondExamRosterPut = (query) => {
  return request({
    url: `${prefix}/recruitRegister/secondExamRoster`,
    method: 'put',
    data: query
  })
}
/**
 * 复试名单（导入）
 * @param {*} query
 */
export const secondExamRosterlmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister/secondExamRoster/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}


/**
 * 录取名单（查询）
 * @param {*} query
 */
export const recruitPrepareList = (query) => {
  return request({
    url: `${prefix}/recruitRegister/recruitPrepare/list`,
    method: 'get',
    params: query
  })
}
/**
 * 录取名单（创建）
 * @param {*} query
 */
export const recruitPrepareCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister/recruitPrepare`,
    method: 'post',
    data: query
  })
}
/**
 * 录取名单（详情）
 * @param {*} query
 */
export const recruitPrepareDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister/recruitPrepare`,
    method: 'get',
    params: query
  })
}
/**
 * 录取名单（编辑）
 * @param {*} query
 */
export const recruitPreparePut = (query) => {
  return request({
    url: `${prefix}/recruitRegister/recruitPrepare`,
    method: 'put',
    data: query
  })
}

/**
 * 录取名单（导入）
 * @param {*} query
 */
export const recruitPreparelmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister/recruitPrepare/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}
/**
 * 录取名单（删除）
 * @param {*} query
 */
export const recruitPrepareDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister/recruitPrepare/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 录取分数线（查询）
 * @param {*} query
 */
export const scoreLine = (query) => {
  return request({
    url: `${prefix}/recruitRegister/scoreLine/list`,
    method: 'get',
    params: query
  })
}
/**
 * 录取分数线（创建）
 * @param {*} query
 */
export const scoreLineCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister/scoreLine`,
    method: 'post',
    data: query
  })
}
/**
 * 录取分数线（批量创建）
 * @param {*} query
 */
export const scoreLineBulkCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister/scoreLine/bulk`,
    method: 'post',
    data: query
  })
}
/**
 * 录取分数线（编辑）
 * @param {*} query
 */
export const scoreLinePut = (query) => {
  return request({
    url: `${prefix}/recruitRegister/scoreLine`,
    method: 'put',
    data: query
  })
}
/**
 * 录取分数线（删除）
 * @param {*} query
 */
export const scoreLineDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister/scoreLine/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 录取分数线（查询详情）
 * @param {*} query
 */
export const scoreLineDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister/scoreLine`,
    method: 'get',
    params: query
  })
}

/**
 * 录取分数线（导入）
 * @param {*} query
 */
export const scoreLinelmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister/scoreLine/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}

/**
 * 参考书目（查询）废弃：/recruitRegister/referenceBook改用：/recruitRegister26/firstBook
 * @param {*} query
 */
export const referenceBookList = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/firstBook/list`,
    method: 'get',
    params: query
  })
}
/**
 * 参考书目（创建）
 * @param {*} query
 */
export const referenceBookCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/firstBook`,
    method: 'post',
    data: query
  })
}
/**
 * 参考书目（查询详情）
 * @param {*} query
 */
export const referenceBookDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/firstBook`,
    method: 'get',
    params: query
  })
}
/**
 * 参考书目（编辑）
 * @param {*} query
 */
export const referenceBookPut = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/firstBook`,
    method: 'put',
    data: query
  })
}
/**
 * 参考书目（删除）
 * @param {*} query
 */
export const referenceBookDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/firstBook/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 参考书目（导入）
 * @param {*} query
 */
export const referenceBooklmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/firstBook/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}
/**
 * 调剂信息（导入）
 * @param {*} query
 */
export const adjustInfolmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister/adjustInfo/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}

/**
 * 复试科目（查询列表）
 * @param {*} query
 */
export const secondSubjectList = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondSubject/list`,
    method: 'get',
    params: query
  })
}
/**
 * 复试科目（导入）
 * @param {*} query
 */
export const secondSubjectlmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondSubject/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}
/**
 * 复试科目（删除）
 * @param {*} query
 */
export const secondSubjectDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondSubject/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 复试科目（创建）
 * @param {*} query
 */
export const secondSubjectCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondSubject`,
    method: 'post',
    data: query
  })
}
/**
 * 复试科目（查询详情）
 * @param {*} query
 */
export const secondSubjectDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondSubject`,
    method: 'get',
    params: query
  })
}
/**
 * 复试科目（编辑）
 * @param {*} query
 */
export const secondSubjectPut = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondSubject`,
    method: 'put',
    data: query
  })
}
/**
 * 同等学历科目（查询列表）
 * @param {*} query
 */
export const degreeSubjectList = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/degreeSubject/list`,
    method: 'get',
    params: query
  })
}
/**
 * 同等学历科目（导入）
 * @param {*} query
 */
export const degreeSubjectlmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/degreeSubject/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}
/**
 * 同等学历科目（删除）
 * @param {*} query
 */
export const degreeSubjectDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/degreeSubject/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 同等学历科目（创建）
 * @param {*} query
 */
export const degreeSubjectCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/degreeSubject`,
    method: 'post',
    data: query
  })
}
/**
 * 同等学历科目（查询详情）
 * @param {*} query
 */
export const degreeSubjectDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/degreeSubject`,
    method: 'get',
    params: query
  })
}
/**
 * 同等学历科目（编辑）
 * @param {*} query
 */
export const degreeSubjectPut = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/degreeSubject`,
    method: 'put',
    data: query
  })
}
/**
 * 复试参考书（查询列表）
 * @param {*} query
 */
export const secondBookList = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondBook/list`,
    method: 'get',
    params: query
  })
}
/**
 * 复试参考书（导入）
 * @param {*} query
 */
export const secondBooklmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondBook/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}
/**
 * 复试参考书（删除）
 * @param {*} query
 */
export const secondBookDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondBook/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 复试参考书（创建）
 * @param {*} query
 */
export const secondBookCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondBook`,
    method: 'post',
    data: query
  })
}
/**
 * 复试参考书（查询详情）
 * @param {*} query
 */
export const secondBookDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondBook`,
    method: 'get',
    params: query
  })
}
/**
 * 复试参考书（编辑）
 * @param {*} query
 */
export const secondBookPut = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/secondBook`,
    method: 'put',
    data: query
  })
}
/**
 * 学制（查询列表）
 * @param {*} query
 */
export const learnSpanList = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnSpan/list`,
    method: 'get',
    params: query
  })
}
/**
 * 学制（导入）
 * @param {*} query
 */
export const learnSpanlmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnSpan/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}
/**
 * 学制（删除）
 * @param {*} query
 */
export const learnSpanDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnSpan/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 学制（创建）
 * @param {*} query
 */
export const learnSpanCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnSpan`,
    method: 'post',
    data: query
  })
}
/**
 * 学制（查询详情）
 * @param {*} query
 */
export const learnSpanDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnSpan`,
    method: 'get',
    params: query
  })
}
/**
 * 学制（编辑）
 * @param {*} query
 */
export const learnSpanPut = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnSpan`,
    method: 'put',
    data: query
  })
}
/**
 * 学费（查询列表）
 * @param {*} query
 */
export const learnTuitionList = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnTuition/list`,
    method: 'get',
    params: query
  })
}
/**
 * 学费（导入）
 * @param {*} query
 */
export const learnTuitionlmport = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnTuition/bulk/byFileImport`,
    method: 'post',
    data: query
  })
}
/**
 * 学费（删除）
 * @param {*} query
 */
export const learnTuitionDelete = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnTuition/list`,
    method: 'delete',
    data: query
  })
}
/**
 * 学费（创建）
 * @param {*} query
 */
export const learnTuitionCreated = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnTuition`,
    method: 'post',
    data: query
  })
}
/**
 * 学费（查询详情）
 * @param {*} query
 */
export const learnTuitionDetail = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnTuition`,
    method: 'get',
    params: query
  })
}
/**
 * 学费（编辑）
 * @param {*} query
 */
export const learnTuitionPut = (query) => {
  return request({
    url: `${prefix}/recruitRegister26/learnTuition`,
    method: 'put',
    data: query
  })
}